window.sliders = function(){
    var gap = 15;

    /*Slider Home*/
    var sliderHome = new Swiper(".slide-home", {
      slidesPerView: "auto",
      spaceBetween: gap,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 4000,
      },
      pagination: {
        el: ".slide-home.swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });

    // var linksSlider = new Swiper(".sliderNav", {
    //   slidesPerView: "auto",
    //   loop: false,
    //   spaceBetween: 10
    // });

    /*Prateleira*/
    // window.prateleiras = [];
    // $(".slide-prateleira").each(function(index) {
    //   let reference = this.closest('.shopify-section').attr('id');
    //   var window.prateleiras[reference] = new Swiper(this, {
    //     slidesPerView: "auto",
    //     loop: false,
    //     spaceBetween: 10,
    //     navigation: {
    //       nextEl: ".swiper-button-next",
    //       prevEl: ".swiper-button-prev",
    //     }
    //   });
    // });

    window.prateleiras = [];
    $(".slide-prateleira").each(function(index) {
      let [reference] = $(this).closest('.shopify-section').attr('id');
      window.prateleiras[reference] = new Swiper(this, {
        slidesPerView: "auto",
        loop: false,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
      });
      window.prateleiras.push(window.prateleiras[reference])
    })
  
    // var prateleira = new Swiper(".slide-prateleira", {
    //   slidesPerView: "auto",
    //   loop: false,
    //   spaceBetween: 10,
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   }
    // });
}

const $trash_icon = '<svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" size="24" color="systemGrayscale00"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.5 4h-3.563a2 2 0 0 0-3.874 0H6.5a1.5 1.5 0 1 0 0 3h11a1.5 1.5 0 0 0 0-3ZM7 9a1 1 0 0 0-1 1v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V10a1 1 0 0 0-1-1H7Z"></path></svg>';
const $minus_icon = '<svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" size="24" color="systemGrayscale00"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 12.5A1.5 1.5 0 0 1 5.5 11h14a1.5 1.5 0 0 1 0 3h-14A1.5 1.5 0 0 1 4 12.5Z"></path></svg>';

function changeIcon($container){
  var $value = parseInt($container.find('input').val());
  var $minusContainer = $container.find('.remove-qtd-product');
  if ($value > 1){
    $minusContainer.html($minus_icon);
  }else if($value == 1){
    $minusContainer.html($trash_icon);
  }
}

$('.add-qtd-product').click(function(){
  let $max_qtd = parseInt($(this).attr('max-qtd'));
  let $qtd_now = parseInt($(this).prev().find('input').val());

  $qtd_now+=1;

  if($qtd_now <= $max_qtd){
    $(this).prev().find('input').val($qtd_now)
    $(this).prev().find('span').html($qtd_now)
    $(this).closest('.add-cart-container').addClass('item-selected')
  }else{
    alert("Limite máximo exedido")
  }

  changeIcon($(this).closest('.add-cart-container'));
})

if (window.history.length > 1 && document.referrer != "") {
  $('[back-history]').show()
}

$('[back-history]').click(function(){
  window.history.back();
})

$(document).ready(function () {
  // $(document).on("mouseenter", ".prateleira-ubercart-item[data-qtd-cart='0']", function() {
  //   let quantity_container = $(this).find('.selector-qtd-background');
  //   quantity_container.find('.btn-add').html(`<svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" size="24" color="systemGrayscale00" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.5A1.5 1.5 0 0 1 13.5 5v5.5H19a1.5 1.5 0 0 1 1.493 1.355L20.5 12a1.5 1.5 0 0 1-1.5 1.5h-5.5V19a1.5 1.5 0 0 1-1.355 1.493L12 20.5a1.5 1.5 0 0 1-1.5-1.5v-5.5H5a1.5 1.5 0 0 1-1.493-1.355L3.5 12A1.5 1.5 0 0 1 5 10.5h5.5V5a1.5 1.5 0 0 1 1.355-1.493L12 3.5Z"></path></svg> Add ao carrinho`);
  // });
  
  // $(document).on("mouseout", ".prateleira-ubercart-item[data-qtd-cart='0']", function() {
  //   let quantity_container = $(this).find('.selector-qtd-background');
  //   quantity_container.find('.btn-add').html(`<svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" size="24" color="systemGrayscale00" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.5A1.5 1.5 0 0 1 13.5 5v5.5H19a1.5 1.5 0 0 1 1.493 1.355L20.5 12a1.5 1.5 0 0 1-1.5 1.5h-5.5V19a1.5 1.5 0 0 1-1.355 1.493L12 20.5a1.5 1.5 0 0 1-1.5-1.5v-5.5H5a1.5 1.5 0 0 1-1.493-1.355L3.5 12A1.5 1.5 0 0 1 5 10.5h5.5V5a1.5 1.5 0 0 1 1.355-1.493L12 3.5Z"></path></svg> Add`);
  // });

  /*Atualizar seletores de quantidade*/
  window.updateItems = function(item){

    let itemContainer = $(`.prateleira-ubercart-item[data-item-prateleira="${item.product_id}"]`);
    let stock = itemContainer.find('[data-stock]').data('stock');

    itemContainer.attr('data-qtd-cart', item.quantity)
    
    Shopify.getCart((cart) => {
        window.updateCart(cart)
    });
     
    if(item.quantity > 1){
      itemContainer.find('.quantity-selector').html(`
          <span class="selector-qtd-background added-multiple-item">
            <button data-quantity="${item.quantity}" decrease-item-cart data-variant-id="${item.variant_id}" data-line-item="${item.key}" aria-label="Diminua a quantidade de ${item.title}" class="btn-minus btn-quantity qtd-grid">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" size="24" color="systemGrayscale00" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 12.5A1.5 1.5 0 0 1 5.5 11h14a1.5 1.5 0 0 1 0 3h-14A1.5 1.5 0 0 1 4 12.5Z"></path></svg>
            </button>
            <span aria-live="polite" aria-atomic="true">
              <span style="border: 0px; clip: rect(0px, 0px, 0px, 0px); height: 1px; margin: -1px; overflow: hidden; padding: 0px; position: absolute; width: 1px; white-space: nowrap; overflow-wrap: normal;">
                Quantidade:</span><span>${item.quantity} un</span>
            </span>
            <button data-stock="${stock}" data-quantity="${item.quantity}" increase-item-cart data-variant-id="${item.variant_id}" data-line-item="${item.key}" aria-label="Aumente a quantidade de ${item.title}" class="btn-plus btn-quantity qtd-grid" ${stock == item.quantity ? 'style="opacity: 0; pointer-events: none"' : ''}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" size="24" color="systemGrayscale00" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.5A1.5 1.5 0 0 1 13.5 5v5.5H19a1.5 1.5 0 0 1 1.493 1.355L20.5 12a1.5 1.5 0 0 1-1.5 1.5h-5.5V19a1.5 1.5 0 0 1-1.355 1.493L12 20.5a1.5 1.5 0 0 1-1.5-1.5v-5.5H5a1.5 1.5 0 0 1-1.493-1.355L3.5 12A1.5 1.5 0 0 1 5 10.5h5.5V5a1.5 1.5 0 0 1 1.355-1.493L12 3.5Z"></path></svg>
            </button>
          </span>
      `);
      return;
    }

    if(item.quantity === 1){
      itemContainer.find('.quantity-selector').html(`
        <span class="selector-qtd-background added-item">
          <button data-quantity="${item.quantity}" remove-item-cart-prateleira aria-label="${item.title}" data-variant-id="${item.variant_id}" data-line-item="${item.key}" class="btn-trash btn-quantity qtd-grid">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" size="24" color="systemGrayscale00" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.5 4h-3.563a2 2 0 0 0-3.874 0H6.5a1.5 1.5 0 1 0 0 3h11a1.5 1.5 0 0 0 0-3ZM7 9a1 1 0 0 0-1 1v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V10a1 1 0 0 0-1-1H7Z"></path></svg>
          </button>
          <span aria-live="polite" aria-atomic="true">
            <span style="border: 0px; clip: rect(0px, 0px, 0px, 0px); height: 1px; margin: -1px; overflow: hidden; padding: 0px; position: absolute; width: 1px; white-space: nowrap; overflow-wrap: normal;">
              Quantidade:
            </span>
            <span>${item.quantity} un</span>
          </span>
          <button data-stock="${stock}" data-quantity="${item.quantity}" increase-item-cart aria-label="Aumente a quantidade de ${item.title}" data-variant-id="${item.variant_id}" data-line-item="${item.key}" class="btn-plus btn-quantity qtd-grid" ${stock == item.quantity ? 'style="opacity: 0; pointer-events: none"' : ''}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" size="24" color="systemGrayscale00" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.5A1.5 1.5 0 0 1 13.5 5v5.5H19a1.5 1.5 0 0 1 1.493 1.355L20.5 12a1.5 1.5 0 0 1-1.5 1.5h-5.5V19a1.5 1.5 0 0 1-1.355 1.493L12 20.5a1.5 1.5 0 0 1-1.5-1.5v-5.5H5a1.5 1.5 0 0 1-1.493-1.355L3.5 12A1.5 1.5 0 0 1 5 10.5h5.5V5a1.5 1.5 0 0 1 1.355-1.493L12 3.5Z"></path></svg>
          </button>
        </span>
      `)
      return;
    }
    
    itemContainer.find('.quantity-selector').html(`
      <div class="selector-qtd-background">
        <button data-stock="${stock}" add-item-cart data-variant-id="${item.id}" aria-label="Adicione ${item?.title}" class="btn-add btn-quantity qtd-grid">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" size="24" color="systemGrayscale00" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.5A1.5 1.5 0 0 1 13.5 5v5.5H19a1.5 1.5 0 0 1 1.493 1.355L20.5 12a1.5 1.5 0 0 1-1.5 1.5h-5.5V19a1.5 1.5 0 0 1-1.355 1.493L12 20.5a1.5 1.5 0 0 1-1.5-1.5v-5.5H5a1.5 1.5 0 0 1-1.493-1.355L3.5 12A1.5 1.5 0 0 1 5 10.5h5.5V5a1.5 1.5 0 0 1 1.355-1.493L12 3.5Z"></path></svg>
          <span class="text-add">Add</span>
        </button>
      </div>
    `)
  }

  window.ajaxAddCart = function(formData){
    let id = formData.id;
    let qtd = formData.quantity;
    
    Shopify.addItem(id, qtd, window.updateItems);
  }

  window.ajaxUpdateCart = function(formData){
    Shopify.changeItem(formData.id, formData.quantity, (cart) => {
        var filteredItem = cart.items.filter(function (item) {
          return item.key === formData.id;
        });
        window.updateItems(filteredItem[0]);
    });
  }

  window.ajaxRemoveCart = function(formData){
    Shopify.removeItem(formData.id, (cart) => {
      window.updateItems(formData);
    });
  }

  function animateItem(item){
    var productImage = item.find("img:first-child").clone().addClass('preview-image-item');

    // Animação para mover o item do produto até o carrinho
    var cartPosition = $(".header__icon--cart").offset();

    if($(window).width() < 1024){
      cartPosition = $(".header-mobile--icon .header__icon--cart").offset();
    }
    productImage.css({
        position: "absolute",
        top: item.offset().top,
        left: item.offset().left
    }).appendTo("body").animate({
        top: cartPosition.top,
        left: cartPosition.left,
        width: 50,
        height: 50
    }, 800, function () {
        productImage.remove();
    });
  }

  /*Add item*/
  $(document).on("click", "[add-item-cart]", function() {
    let variantId = parseInt($(this).data('variant-id'));
    let input = this;
    
    let formData = {
      'id': variantId,
      'quantity': 1,
      'input': input
    };

    var item = $(this).closest('.prateleira-ubercart-item');
    animateItem(item)
    
    window.ajaxAddCart(formData);
  })
  
  /*Decrease item*/
  $(document).on("click", "[decrease-item-cart]", function() {
    let variantId = $(this).data('line-item');
    let qtd = parseInt($(this).data('quantity')) - 1;

    let formData = {
      "id" : variantId,
      "quantity" : qtd
    }
    
    window.ajaxUpdateCart(formData);
    
  })
  
  /*Increase item*/
  $(document).on("click", "[increase-item-cart]", function() {
    let variantId = $(this).data('line-item');
    let qtd = parseInt($(this).data('quantity')) + 1;
    let stock = parseInt($(this).data('stock'));
    let input = "";

    if(stock < qtd){
      alert(`Temos apenas ${stock} em estoque`)
      return;
    }
    
    let formData = {
      'id': variantId,
      'quantity': qtd,
      'input': input
    };

    var item = $(this).closest('.prateleira-ubercart-item');
    animateItem(item)
    
    window.ajaxUpdateCart(formData);
    
  })
  
  /*Remove item*/
  $(document).on("click", "[remove-item-cart-prateleira]", function() {
    let variantId = $(this).data('line-item');

    let formData = {
      "id" : variantId,
      "quantity": 0,
      "title": $(this).attr('aria-label'),
      "product_id": $(this).closest('.prateleira-ubercart-item').data('item-prateleira')
    }
    window.ajaxRemoveCart(formData);
  })

  $('.menu-open').click(function(){
    $('body').toggleClass('show-menu-sidebar');
  });

  window.revertSidebarUbercart = function(){
    if($('body').hasClass('show-menu-sidebar')){
      $('body').removeClass('show-menu-sidebar')
    }
  }

  window.applySidebarUbercart = function(){
    if(!$('body').hasClass('show-menu-sidebar')){
      $('body').addClass('show-menu-sidebar')
    }
  }

  // $('.button-checkout[next-step-cart]').click(function(e){
  //   e.preventDefault();
  //   $('#agendamento-cart').show();
  //   $('#cart-items-resume').hide();
  // })

  $('[data-reorder]').click(function(e) {
    // Obtenha os itens do atributo data-items e converta para objeto JavaScript
    let json = $(this).attr('data-items');
    let items = JSON.parse(json.replace(/'/g, '"'));
  
    // Construa um objeto de atualizações no formato esperado pela API do Shopify
    let updates = {};
    items.forEach(item => {
      updates[item.variant_id] = parseInt(item.quantity, 10);
    });
  
    // Construa a requisição AJAX
    $.ajax({
      type: 'POST',
      url: window.Shopify.routes.root + 'cart/update.js',
      data: { updates: updates },
      success: function(response) {
        console.log('Itens adicionados com sucesso ao carrinho:', response);
        // Lidar com a resposta do servidor, se necessário
      },
      error: function(error) {
        console.error('Erro ao adicionar itens ao carrinho:', error);
        // Lidar com erros, se necessário
      }
    });
  });
});

document.addEventListener('click', function(e) {
  if (e.target.matches('.button-checkout')) {
    e.preventDefault();

    let agendamentoCart = document.getElementById('agendamento-cart');

    if (!(agendamentoCart.offsetWidth > 0 && agendamentoCart.offsetHeight > 0)) {
      let activeDates = document.querySelectorAll('.datepicker-days td.day.active');
      if (activeDates.length === 0) {
        e.target.setAttribute('disabled', 'disabled');
      }
      
      let previewCartAction = document.querySelector('.previewCartAction');
      if (previewCartAction) {
        let div = document.createElement('div');
        div.innerHTML = `<div class="previewCartGroup container-back-products"><button class="button button-1 button-back-products" prev-step-cart="">Voltar aos produtos</button></div>`;
        previewCartAction.insertBefore(div.firstChild, previewCartAction.firstChild);
      }
      agendamentoCart.style.display = 'block';
      document.getElementById('cart-items-resume').style.display = 'none';
    } else {
      var text = 'Entrega: ' + window.data + '/' + window.mes + ' - ' + window.horas;
    
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ note: text }),
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Network response was not ok.');
      })
      .then(data => {
        window.location.href = window.Shopify.routes.root + 'checkout';
      })
      .catch(error => console.error('There has been a problem with your fetch operation:', error));
    }
  }
  
  let target = e.target.closest('[prev-step-cart]');
  
  if (target) {
    e.preventDefault();

    let containerBackProducts = target.closest('.container-back-products');
    if (containerBackProducts) {
      containerBackProducts.parentNode.removeChild(containerBackProducts);
    }

    let buttonCheckout = document.querySelector('.button-checkout');
    if (buttonCheckout) {
      buttonCheckout.disabled = false;
      buttonCheckout.classList.remove('disabled');
    }

    let agendamentoCart = document.getElementById('agendamento-cart');
    if (agendamentoCart) {
      agendamentoCart.style.display = 'none';
    }

    let cartItemsResume = document.getElementById('cart-items-resume');
    if (cartItemsResume) {
      cartItemsResume.style.display = 'block';
    }
  }
});
